// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"_--z"};